import { render } from "./SelectProfileGroup.vue?vue&type=template&id=02b720ba&scoped=true&ts=true"
import script from "./SelectProfileGroup.vue?vue&type=script&lang=ts"
export * from "./SelectProfileGroup.vue?vue&type=script&lang=ts"

import "./SelectProfileGroup.vue?vue&type=style&index=0&id=02b720ba&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b720ba"]])

export default __exports__